import type { IconProps } from './../../models/icon';

export function CopyIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M15.4285 4.28571H5.14275C4.19599 4.28571 3.42847 5.05323 3.42847 5.99999V21.4286C3.42847 22.3754 4.19599 23.1428 5.14275 23.1428H15.4285C16.3752 23.1428 17.1428 22.3754 17.1428 21.4286V5.99999C17.1428 5.05323 16.3752 4.28571 15.4285 4.28571Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M15.4285 4.28571H5.14275C4.19599 4.28571 3.42847 5.05323 3.42847 5.99999V21.4286C3.42847 22.3754 4.19599 23.1428 5.14275 23.1428H15.4285C16.3752 23.1428 17.1428 22.3754 17.1428 21.4286V5.99999C17.1428 5.05323 16.3752 4.28571 15.4285 4.28571Z"
      />

      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M7.71436 0.857178H18.8572C19.3118 0.857178 19.748 1.03779 20.0694 1.35928C20.3908 1.68077 20.5715 2.1168 20.5715 2.57146V18.8572"
      />
    </svg>
  );
}
